import { combineReducers } from "redux";
import menu from "./menu";
import appMembership from "pages/membership/membershipStore/store";

const reducers = combineReducers({ menu, appMembership });

export default reducers;
